import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useRef, useState, useEffect } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { projectPageName } from '../components/PageName';
import { useCreateProjectMutation, useLazyGetProjectByIdQuery, useUpdateProjectMutation } from '../features/project/projectSlice';
import FormDropDownList from '../components/FormDropDownList';
import { useLazyGetContractDDLQuery } from '../features/contract/ContractSlice';
import { ContractItemModel } from '../models/ContractItemModel';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useTranslation } from "react-i18next";

const AddProjectPage = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    var project = getLocation?.state?.project;
    var contractData = getLocation?.state?.contract;
    console.log("project", project)
    const [getProjectQuery] = useLazyGetProjectByIdQuery();

    const [projectNum, setProjectNum] = useState("");
    const [projectName, setProjectName] = useState("");
    const [projectCompany, setProjectCompany] = useState("");
    const [projectManager, setProjectManager] = useState("");
    const [tel, setTel] = useState("");
    // const [showAlert, setShowAlert] = useState("");
    const [startDate, setStartDate] = useState(dayjs(null));
    const [endDate, setEndDate] = useState(dayjs(null));
    const [createProject] = useCreateProjectMutation();
    const [updateProject] = useUpdateProjectMutation();
    const [getContractDDL] = useLazyGetContractDDLQuery();
    const [contractNumber, setContractNumber] = useState("");
    const [contractTitle, setContractTitle] = useState("");
    const [contractId, setContractId] = useState(contractData || "");
    const [contract, setContract] = useState<ContractItemModel[]>([]);
    const [openConfirmationBox, setOpenConfirmationBox] = useState(false)

    useEffect(() => {
        getContractDDL().then((res) => {
            if (res.status == 'fulfilled') {
                const contractItems: ContractItemModel[] = res.data.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                    title: item.title,
                }));
                setContract(contractItems);
                if (contractData) {
                    const selectedContract = contractItems.find((item) => item.id == contractId);
                    setContractNumber(selectedContract ? selectedContract?.name : "");
                    setContractTitle(selectedContract ? selectedContract?.title : "");
                    setContractId(selectedContract?.id);
                    // console.log(selectedContract)
                }
            }
        }).then(() => handleProjectData());
    }, []);

    const handleProjectData = async () => {
        try {
            if (localStorage.accessToken) {
                if (project?.projectId || project?.id) {
                    getProjectQuery(project?.projectId || project?.id)
                        .then((respone) => {
                            if (respone.status == 'fulfilled') {
                                setProjectNum(respone?.data?.number)
                                setProjectName(respone?.data?.name)
                                setStartDate(dayjs(respone?.data?.startDate, 'DD/MM/YYYY'))
                                setEndDate(dayjs(respone?.data?.endDate, 'DD/MM/YYYY'))
                                setProjectCompany(respone?.data?.companyName)
                                setProjectManager(respone?.data?.manager)
                                setTel(respone?.data?.telephone)
                                setContractNumber(respone?.data?.contractNumber)
                                setContractTitle(respone?.data?.contractTitle)
                                setContractId(respone?.data?.contractId)
                            }
                        })
                }
            }
        } catch (error) {
            setOpenConfirmationBox(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error);
        } finally {
        }
    };

    const handleCreateProject = async () => {
        try {
            if (localStorage.accessToken) {

                project = {
                    // id: "",
                    contractId: contractId?.toString(),
                    contractNumber: contractNumber?.toString(),
                    contractTitle: contractTitle?.toString(),
                    number: projectNum?.toString(),
                    name: projectName?.toString(),
                    startDate: startDate.format("DD/MM/YYYY").toString(),
                    endDate: endDate.format("DD/MM/YYYY").toString(),
                    companyName: projectCompany?.toString(),
                    manager: projectManager?.toString(),
                    telephone: tel?.toString(),
                    // alert: showAlert?.toString(),
                }
                createProject(project)
                    .then((res) => {
                        if ('error' in res) {
                            console.log(res.error);
                            alert(`Create Project failed: ${res.error}`)
                            setOpenConfirmationBox(false);
                        }
                        else {
                            alert("Create Project Success")
                            setOpenConfirmationBox(false);
                            navigate('/project-detail', { state: res?.data })
                        }
                    })
            }
        }
        catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }

    const onCloseConfirmationBox = function () {
        setOpenConfirmationBox(false)
    }

    const onOpenConfirmationBox = function () {
        setOpenConfirmationBox(true)
    }

    const handleUpdateProject = async () => {

        try {
            if (localStorage.accessToken) {

                project = {
                    id: project?.projectId || project?.id,
                    contractId: contractId?.toString(),
                    contractNumber: contractNumber?.toString(),
                    contractTitle: contractTitle?.toString(),
                    number: projectNum?.toString(),
                    name: projectName?.toString(),
                    startDate: startDate.format("DD/MM/YYYY").toString(),
                    endDate: endDate.format("DD/MM/YYYY").toString(),
                    companyName: projectCompany?.toString(),
                    manager: projectManager?.toString(),
                    telephone: tel?.toString(),
                    // alert: showAlert?.toString(),

                }
                updateProject(project).then((res) => {
                    if ('error' in res) {
                        console.log(res.error);
                        alert(`Update failed: ${res.error}`)
                        setOpenConfirmationBox(false);
                    }
                    else {
                        alert("Update Success")
                        setOpenConfirmationBox(false);
                        navigate('/project-detail', { state: res?.data })
                    }
                })
            };
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }
    const handleContractNumChange = (event: any) => {
        const selectedContract = contract.find((item) => item.name === event.target.value);
        setContractNumber(event.target.value);
        setContractTitle(selectedContract ? selectedContract.title : '');
        setContractId(selectedContract ? selectedContract.id : '');
        console.log(selectedContract)
    };

    return (
        <MainContent type={projectPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    {!project && <BigHeading>{t("Add New Project")}</BigHeading>}
                    {project && <BigHeading>{t("Edit Project Detail")}</BigHeading>}
                    <FormDropDownList
                        sameRowTitle={t("Contract No.")}
                        value={contractNumber}
                        handleValueChange={handleContractNumChange}
                        items={contract.map(item => item.name)}
                    />
                    <FormLabel title={t("Contract Name")} value={contractTitle} />
                    <FormInput title={t("Project No.")} value={projectNum} setMethod={setProjectNum} />
                    <FormInput title={t("Project Name")} value={projectName} setMethod={setProjectName} />
                    <FormDatePicker title={t("Start Date")} value={startDate} setMethod={setStartDate} />
                    <FormDatePicker title={t("End Date")} value={endDate} setMethod={setEndDate} />
                    <FormInput title={t("Project Company")} value={projectCompany} setMethod={setProjectCompany} />
                    <FormInput title={t("Project Manager")} value={projectManager} setMethod={setProjectManager} />
                    <FormInput title={t("Tel")} value={tel} setMethod={setTel} />
                    {/* <FormCheckbox title={"Alert"} value={!showAlert} setMethod={setShowAlert} checkboxLabel={"None"}></FormCheckbox> */}
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={onOpenConfirmationBox}>{t("Save")}</ShortBlueButton>
                        {!project && !contractData && <BackButton onClick={() => { navigate('/project') }}>{t("Back")}</BackButton>}
                        {contractData && <BackButton onClick={() => { navigate('/contract-detail', { state: contractData }) }}>{t("Back")}</BackButton>}
                        {project && <BackButton onClick={() => { navigate(`/project-detail`, { state: project }); }}>{t("Back")}</BackButton>}
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
            <ModalConfirmationBox description={project ? "Are you sure to update this project?" : "Are you sure to add new project?"} open={openConfirmationBox} onClose={onCloseConfirmationBox} onConfirm={project ? handleUpdateProject : handleCreateProject} />
        </MainContent>
    );
};

export default AddProjectPage;